import React from 'react';
import { aboutUs } from '../data/mock';

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Title */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-0.5 bg-burgundy" />
              <span className="text-burgundy text-sm tracking-widest uppercase font-medium">
                Who We Are
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-charcoal leading-tight mb-8">
              {aboutUs.title}
            </h2>
            <div className="w-24 h-1 bg-gold" />
          </div>

          {/* Right Column - Content */}
          <div className="space-y-6">
            {aboutUs.paragraphs.map((paragraph, index) => (
              <p
                key={index}
                className={`text-lg leading-relaxed ${
                  index === 0 ? 'text-charcoal font-medium' : 'text-slate'
                }`}
              >
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 p-8 bg-charcoal">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-gold mb-2">€45M+</div>
            <div className="text-ivory/80 text-sm">Capital Mobilized</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-gold mb-2">$35M+</div>
            <div className="text-ivory/80 text-sm">Projects Advised</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-gold mb-2">20+</div>
            <div className="text-ivory/80 text-sm">Institutions Supported</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-gold mb-2">2+</div>
            <div className="text-ivory/80 text-sm">Countries Served</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
